<template>
  <div class="flex min-h-[calc(100vh-140px)]">
    <!-- Column 1 Skeleton -->
    <div class="flex flex-col flex-1 p-6 gap-6">
      <div class="flex gap-10">
        <div class="flex flex-col gap-6">
          <div class="w-[200px] h-6 rounded bg-zinc-200 animate-pulse" />
          <div class="w-[150px] h-6 rounded bg-zinc-200 animate-pulse" />
          <div class="w-[200px] h-6 rounded bg-zinc-200 animate-pulse" />
          <div class="w-[150px] h-6 rounded bg-zinc-200 animate-pulse" />
        </div>
      </div>
    </div>

    <!-- Column 2 Skeleton (Sidebar) -->
    <div class="flex max-w-[413px] min-w-[413px] flex-col gap-6 p-6 bg-zinc-50 border-t border-l border-zinc-200">
      <div class="w-[300px] h-10 rounded bg-zinc-200 animate-pulse" />
      <div class="w-[250px] h-10 rounded bg-zinc-200 animate-pulse" />
      <div class="w-[300px] h-10 rounded bg-zinc-200 animate-pulse" />
      <div class="w-[300px] h-10 rounded bg-zinc-200 animate-pulse" />
    </div>
  </div>
</template>
